module.exports = __webpack_public_path__ + "static/wavevdo-8c2e750c68926e07c8556b8b807cef67.mp4";